import { ref } from 'vue';
import { defineStore } from 'pinia';
import { createStorage } from '@aviata/storage';
import type { MappedLocation } from 'shared';

import {
  defaultDepartureCityCode,
  defaultDepartureCityNames,
} from '@/shared/config';

import { DEPARTURE_CITY_STORAGE_KEY } from '../config';

const storage = createStorage(localStorage);

export const useSpecialOffersStore = defineStore('special-offers', () => {
  const origCity = ref<MappedLocation>(
    JSON.parse(
      storage.get(
        DEPARTURE_CITY_STORAGE_KEY,
        JSON.stringify({
          code: defaultDepartureCityCode,
          ...defaultDepartureCityNames,
        }),
      ),
    ),
  );

  function changeOrigCity(city: MappedLocation) {
    origCity.value = city;
    storage.set(DEPARTURE_CITY_STORAGE_KEY, JSON.stringify(city));
  }

  return {
    origCity,
    changeOrigCity,
  };
});
